import { repetitionConstants } from "./constants";
import { defAction } from "../../../../helpers/defaultAction";
import api from "./api";

export const repetitionActions = {
  getPotentialRepeatedReOrgAppeals
};

function getPotentialRepeatedReOrgAppeals(values) {
  const dispatchObj = {
    constants: repetitionConstants.GetPotentialRepeatedReOrgAppeals,
    service: {
      func: api.getPotentialRepeatedReOrgAppeals,
      params: values,
    },
  };

  return defAction(dispatchObj);
}